import {prismaClient} from '@/helpers/prismaClient.server';
import {createServerFn} from '@tanstack/react-start';

/** Meters per mile */
const METERS_PER_MILE = 1609.34;

/**
 * Returns the longest route distance (in miles) across all future events.
 * Used to set the upper bound on the distance slider.
 */
export const getMaxEventDistance = createServerFn({method: 'GET'}).handler(
  async () => {
    const prisma = await prismaClient();

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const result = await prisma.route.aggregate({
      _max: {distance_meters: true},
      where: {
        distance_meters: {not: null},
        event: {
          OR: [
            {endDate: {gte: today}},
            {endDate: null, startDate: {gte: today}},
            {endDate: null, startDate: null},
          ],
        },
      },
    });

    const maxMeters = result._max.distance_meters ?? 0;
    // Round up to the nearest 5 miles
    const maxMiles = Math.ceil(maxMeters / METERS_PER_MILE / 5) * 5;

    return {maxDistance: Math.max(maxMiles, 10)};
  }
);
